import { Dispatch } from "redux";
import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import { format } from "date-fns";
import { setFormValues } from "../EditCertificateModalSlice";
import { getUserFullName } from "../../../common/utils/getUserFullName";
import { getQualificationFormValidityValues } from "../../../common/utils/getQualificationFormValidityValues";

interface Props {
    dispatch: Dispatch;
    certificate?: CertificateInterface;
}

export const setFormFields = (props: Props): void => {
    const { dispatch, certificate } = props;

    if (!certificate) {
        return;
    }

    let expiresAt = null;

    if (certificate.expires_at) {
        expiresAt = format(certificate.expires_at, "dd-MM-yyyy");
    }

    dispatch(
        setFormValues({
            qualification: getQualificationFormValidityValues(
                certificate?.qualification,
            ),
            employee: {
                selectedId: certificate?.employee?.id?.toString(),
                selectedValue:
                    getUserFullName(certificate?.employee?.user) ?? "",
            },
            educator: {
                selectedId: certificate?.educator?.id?.toString(),
                selectedValue: certificate?.educator?.name,
            },
            validAt: format(certificate?.valid_at, "yyyy-MM-dd"),
            expiresAt: expiresAt,
            fileName: certificate?.certificate_file?.file_name,
        }),
    );
};
